import { IconButtonTestIdFactory } from '../../buttons/interactions';
export const ModalTestIdFactory = {
    // bases
    getModalBase: () => 'modal',
    getModalCloseButtonBase: () => [ModalTestIdFactory.getModalBase(), 'close'].join('-'),
    getModalDescriptionBase: () => [ModalTestIdFactory.getModalBase(), 'subtitle'].join('-'),
    getModalTitleBase: () => [ModalTestIdFactory.getModalBase(), 'title'].join('-'),
    // for test id generation
    getModalDialogTestId: (testId) => [ModalTestIdFactory.getModalBase(), testId].join('-'),
    getModalCloseButtonTestId: () => IconButtonTestIdFactory.getIconButtonTestId(ModalTestIdFactory.getModalCloseButtonBase()),
};
